import SubCategoryLaunchers from "@/components/SubCategoryLaunchers.vue";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
let { hasValue } = useBuilderShowIf();
import * as themeColors from "@assets/styles/colors.module.scss";
const colors = ["Default", ...Object.keys(themeColors)];
export const subCategoryLaunchers = {
    component: SubCategoryLaunchers,
    models: ["category-landing-content"],
    name: "Sub Category Launchers",
    inputs: [
        {
            name: "textBelow",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "columns",
            type: "string",
            enum: ["two", "three", "four"]
        },
        {
            name: "isFullWidth",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "togglePadding",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "useGradient",
            friendlyName: "Image Gradient",
            type: "boolean",
            showIf: hasValue("isFullWidth")
        },
        {
            name: "gradientColor",
            friendlyName: "Image Gradient Color",
            helperText: "",
            type: "string",
            enum: ['Default', ...colors.slice(1)],
            showIf: hasValue("useGradient")
        },
    ]
};
